import { render, staticRenderFns } from "./Vaaratilannehavainto.vue?vue&type=template&id=aca02c1c&scoped=true"
import script from "./Vaaratilannehavainto.vue?vue&type=script&lang=js"
export * from "./Vaaratilannehavainto.vue?vue&type=script&lang=js"
import style0 from "./Vaaratilannehavainto.vue?vue&type=style&index=0&id=aca02c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca02c1c",
  null
  
)

export default component.exports